import PropTypes from "prop-types";

const ROLE_CARDS = [
  {
    role: "CHRO",
    company: "Larsen & Toubro",
    quote:
      "The session helped shift the conversation from what AI can do, to how leaders should work with AI, responsibly and thoughtfully. Practical, clear, and hands-on.",
  },
  {
    role: "L&D Head",
    company: "DTSS",
    quote:
      "The program gave our team a real edge. From day one, they were applying what they learned. The curriculum was sharp, relevant, and built for our industry.",
  },
  {
    role: "Chief People Officer",
    company: "KFintech",
    quote:
      "We saw a measurable shift in how our teams approach problem-solving with AI. Outskill delivered exactly what we needed. No fluff, just results.",
  },
];

const LINKEDIN_CARDS = [
  {
    name: "Milesh Gogad",
    headline: "Chief Marketing Officer",
    body: [
      "We attended an AI in Marketing training expecting tons of 101s on futuristic platforms. What we got instead was… a gentle reality check.",
      "Turns out, AI tools are a lot like Microsoft Office 20 years ago - everyone can access them, many can claim advanced-level expertise, but the real differentiator is how you use them. Bac…",
    ],
    image: "/b2b/b2b1.webp",
    linkedinUrl:
      "https://www.linkedin.com/posts/mileshgogad_we-attended-an-ai-in-marketing-training-expecting-share-7391411680955531264-qp9N/?utm_source=share&utm_medium=member_desktop&rcm=ACoAABSJ3GIB6ljpjw54s9HwvaZOhmatub4qys4",
  },
  {
    name: "Utkarsh Heda",
    headline: "Building Livspace | AI Generalist",
    body: [
      "🚀 Revolutionizing Brand Creativity with AI: Unilever Workshop Success Story",
      "Last week, GrowthSchool and Outskill had the incredible opportunity to conduct an exclusive Gen AI workshop for Unilever - one of India's leading FMCG giants that touches 9 out of 10 households in the country!",
      "As part of GrowthSchool's mission to help professionals bec…",
    ],
    image: "/b2b/b2b2.webp",
    linkedinUrl:
      "https://www.linkedin.com/posts/utkarsh-heda_generativeai-aiinmarketing-brandinnovation-activity-7348991133277921282-oiq8?utm_source=share&utm_medium=member_desktop&rcm=ACoAADMNQs8B9nhi9NNrEOd1YLJ1cw7-8Da34Lw",
  },
];

const RoleCard = ({ card }) => (
  <div className="border border-[#666666] rounded-[2px] p-6 bg-[#08090A] h-full">
    <h3 className="text-[#FFFFFF] text-[18px] md:text-[20px] font-medium">
      {card.role}
    </h3>
    <p className="text-white/50 text-sm md:text-base mt-1">{card.company}</p>
    <p className="text-[#6E6E6E] text-sm md:text-base leading-relaxed mt-6">
      {card.quote}
    </p>
  </div>
);

RoleCard.propTypes = {
  card: PropTypes.shape({
    role: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
    quote: PropTypes.string.isRequired,
  }).isRequired,
};

const LinkedinCard = ({ card }) => (
  <a
    href={card.linkedinUrl}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`${card.name} on LinkedIn`}
    className="relative block border border-[#666666] rounded-[2px] p-6 bg-[#08090A] hover:border-white/40 transition"
  >
    <img
      src="/b2b/b2blink.svg"
      alt="LinkedIn"
      width="42"
      height="42"
      className="absolute top-0 right-0 h-[42px] w-[42px]"
    />

    <h3 className="text-white text-[18px] md:text-[20px] font-medium pr-14">
      {card.name}
    </h3>
    <p className="text-white/60 text-sm md:text-base mt-1">{card.headline}</p>

    <div className="mt-6 space-y-3 text-[#6E6E6E] text-sm md:text-base font-normal leading-relaxed">
      {card.body.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </div>

    <div className="mt-6">
      <img
        src={card.image}
        alt=""
        loading="lazy"
        decoding="async"
        className="w-full h-auto rounded-[2px] object-cover border border-[#FFFFFF4F]"
      />
    </div>
  </a>
);

LinkedinCard.propTypes = {
  card: PropTypes.shape({
    name: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    body: PropTypes.arrayOf(PropTypes.string).isRequired,
    image: PropTypes.string.isRequired,
    linkedinUrl: PropTypes.string.isRequired,
  }).isRequired,
};

const BusinessTestimonials = () => {
  return (
    <section
      id="business-testimonials"
      className="w-full bg-[#08090A] font-fira-sans"
      style={{
        borderTop: "1px solid rgba(255,255,255,0.15)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
      }}
    >
      <div
        className="w-[90%] md:w-auto mx-auto md:mx-[153px]"
        style={{
          borderLeft: "1px solid rgba(255,255,255,0.15)",
          borderRight: "1px solid rgba(255,255,255,0.15)",
        }}
      >
        <div className="px-4 md:pl-[60px] md:pr-[60px] py-16">
          <p className="text-white/70 uppercase tracking-[1.75px] text-sm mb-4">
            Hear it from the teams
          </p>
          <h2 className="text-white text-[30px] md:text-[42px] font-medium leading-tight">
            Trusted by teams across industries
          </h2>

          {/* Row 1 — 3 role cards (desktop); single column on mobile */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12">
            {ROLE_CARDS.map((card) => (
              <RoleCard key={card.role + card.company} card={card} />
            ))}
          </div>

          {/* Row 2 — 2 LinkedIn cards (desktop); single column on mobile */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
            {LINKEDIN_CARDS.map((card) => (
              <LinkedinCard key={card.name} card={card} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessTestimonials;
